module.exports = __webpack_public_path__ + "img/9_83.387d090c.png";